import { DocumentActionTypes } from './document.model'

export const DocumentActions = {
  addImageToDocument: (file: File, onImageAdded: (imageUrl: string) => void) => ({
    type: DocumentActionTypes.ADD_IMAGE_TO_DOCUMENT,
    file,
    onImageAdded,
  }),
}
